/**
 * BCH Registration Data Storage Utility
 * Handles saving and loading BCH registration data
 */

/**
 * Save BCH registration data to localStorage
 * @param {Array} registrationData - Array of objects with ecc, hashHex, r, helper
 * @returns {boolean} Success status
 */
export const saveBCHRegistrationData = (registrationData) => {
  console.log("Saving BCH registration data to localStorage:", registrationData.length, "objects");
  try {
    localStorage.setItem('bchRegistrationData', JSON.stringify(registrationData));
    console.log('BCH registration data saved to localStorage');
    return true;
  } catch (error) {
    console.error('Failed to save BCH registration data:', error);
    return false;
  }
};

/**
 * Load BCH registration data from localStorage
 * @returns {Array|null} Array of registration data objects or null
 */
export const loadBCHRegistrationData = () => {
  try {
    const storedData = localStorage.getItem('bchRegistrationData');
    if (storedData) {
      const parsed = JSON.parse(storedData);
      console.log('BCH registration data loaded from localStorage:', parsed.length, 'objects');
      return parsed;
    }
    return null;
  } catch (error) {
    console.error('Failed to load BCH registration data:', error);
    return null;
  }
};

/**
 * Clear BCH registration data from localStorage
 */
export const clearBCHRegistrationData = () => {
  try {
    localStorage.removeItem('bchRegistrationData');
    console.log('BCH registration data cleared');
    return true;
  } catch (error) {
    console.error('Failed to clear BCH registration data:', error);
    return false;
  }
};

/**
 * Export BCH registration data as JSON file
 * @param {Array} registrationData - Array of registration data objects
 * @param {string} filename - Optional filename (default: bch_registration_data.json)
 */
export const exportBCHDataToFile = (registrationData, filename = 'bch_registration_data.json') => {
  try {
    const dataStr = JSON.stringify(registrationData, null, 2);
    const dataBlob = new Blob([dataStr], { type: 'application/json' });
    const url = URL.createObjectURL(dataBlob);
    const link = document.createElement('a');
    link.href = url;
    link.download = filename;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    URL.revokeObjectURL(url);
    console.log('BCH registration data exported to file:', filename);
    return true;
  } catch (error) {
    console.error('Failed to export BCH registration data:', error);
    return false;
  }
};

/**
 * Import BCH registration data from JSON file
 * @param {File} file - File object to import
 * @returns {Promise<Array|null>} Parsed registration data or null
 */
export const importBCHDataFromFile = (file) => {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onload = (e) => {
      try {
        const data = JSON.parse(e.target.result);
        console.log('BCH registration data imported from file:', data.length, 'objects');
        resolve(data);
      } catch (error) {
        console.error('Failed to parse imported file:', error);
        reject(error);
      }
    };
    reader.onerror = (error) => {
      console.error('Failed to read file:', error);
      reject(error);
    };
    reader.readAsText(file);
  });
};

